module.exports = __webpack_public_path__ + "assets/img/DB-Results-2-Service-Page-w720.b17fc7d5.webp";